import React from "react";

import { EventTheme } from "../../../types";

import { ChristmasTheme } from "./ChristmasTheme";

type Props = {
  eventTheme: EventTheme;
};

export const LogoDecoration: React.FC<Props> = ({ eventTheme }) => {
  const getThemeType = () => {
    switch (eventTheme) {
      case "christmas": {
        return <ChristmasTheme />;
      }
      default: {
        return null;
      }
    }
  };

  return getThemeType();
};
